import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m8 5.22 2.113 2.113.94-.94-3.054-3.06-3.06 3.06.947.94zm0-3.333L10.112 4l.94-.94L7.999 0 4.94 3.06l.947.94zm0 12.226L5.885 12l-.94.94L8 16l3.06-3.06-.946-.94zm0-3.333L5.885 8.667l-.94.94L8 12.667l3.06-3.06-.946-.94z"
    }, null, -1)
  ]))]))
}
export default { render: render }